import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: {
      title: '首都信息-智慧组工',
    }
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('../views/solution.vue'),
    meta: {
      title: '解决方案',
    },

  },
  {
    path: '/solutiondetails',
    name: 'solutionDetails',
    component: () => import('../views/solutionDetails.vue'),
    meta: {
      title: '解决方案详情',
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product.vue'),
    meta: {
      title: '产品',
    }
  }, {
    path: '/productDetails',
    name: 'productDetails',
    component: () => import('../views/productDetails.vue'),
    meta: {
      title: '产品详情',
    }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/case.vue'),
    meta: {
      title: '成功案例',
    }
  },
  {
    path: '/technicalsupport',
    name: 'technicalSupport',
    component: () => import('../views/technicalSupport.vue'),
    meta: {
      title: '技术支持',
    }
  },
  {
    path: '/aboutus',
    name: 'aboutUs',
    component: () => import('../views/aboutUs.vue'),
    meta: {
      title: '关于我们',
    }
  },
  {
    path: '/organizationintroduce',
    name: 'organizationintroduce',
    component: () => import('../views/organizationintroduce.vue'),
    meta: {
      title: '业务介绍',
    }
  },
  {
    path: '*',
    component: () => import('../views/home.vue'),
    meta: {
      title: '首都信息-智慧组工',
    }
  },


]

const router = new VueRouter({
  mode: 'hash', // 'history' hash,
  base: process.env.BASE_URL,
  routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0) //滚动条至于浏览器顶部
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router